export default function chakraTokenToVar(token: string): string {
  return `var(--chakra-colors-${token.replaceAll('.', '-')})`
}
